<template>
    <div class="body">
        <v-toolbar flat color="white">
            <v-toolbar-title>Leaves</v-toolbar-title>
            <v-divider
                    class="mx-2"
                    inset
                    vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-btn color="primary" dark @click.native.stop="dialog = true">New</v-btn>
        </v-toolbar>
        <v-dialog v-model="dialog" max-width="500">
            <v-card>
                <div>
                    <v-container>
                        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                            <p class="headline">Take a Leave:</p>
                            <v-radio-group
                                    v-model="model.type"
                                    row
                            >
                                <v-radio
                                        label="Half"
                                        value="0"
                                ></v-radio>
                                <v-radio
                                        label="Full"
                                        value="1"
                                ></v-radio>
                            </v-radio-group>
                            <v-textarea
                                    :rules="requiredRules"
                                    v-model="model.reason"
                                    placeholder="reason"
                                    rows="2"
                                    style="padding: 0 10px"
                            ></v-textarea>
                            <v-checkbox label="Paid" v-model="model.paid"></v-checkbox>
                            <v-select
                                    label="Select Category"
                                    :items="['PERSONAL','SICK']"
                                    v-model="model.category"
                            ></v-select>
                            <div v-if="model.type == 1">
                                <choose-date v-model="model.start" label="Start Date"/>
                                <choose-date v-model="model.end" label="End Date"/>
                            </div>

                            <div v-if="model.type == 0">
                                <choose-date v-model="model.date" label="Date"/>
                            </div>
                            <v-btn color="primary" @click="submit">Submit</v-btn>
                        </v-form>
                    </v-container>
                </div>
            </v-card>
        </v-dialog>

        <DataTable
                ref="datatable"
                :url="api.ACTIONS.LEAVES"
                :titles="titles"
                :formatter="formatter"
                :fields-hidden-main="['updated_at','created_at','user_id','handler_id','first_name','last_name']"
                :fields-extra-main="fieldsExtraMain"
                :enableEdit="false"
                :disableSearch="true"
                :enableAdd="false"
                :enable-delete="false"
        />
    </div>


</template>

<script>
    import DataTable from "@/components/wasilni/DataTable";
    import ChooseDate from "@/components/wasilni/input/ChooseDate";
    import ChooseTime from "@/components/wasilni/input/ChooseTime";


    export default {
        name: "MyLeaves",
        title: 'My Leaves',
        components: {DataTable, ChooseDate, ChooseTime},
        data() {
            return {
                dialog: false,
                snackbar: false,
                message: "",
                valid: true,
                lazy: false,
                loading: false,
                requiredRules: [(v) => !!v || "الحقل مطلوب"],
                model: {
                    reason: "",
                    start: "",
                    end: "",
                    type: 0,
                    paid: 0,
                },
                datetime: {
                    startDate: null,
                    endDate: null,
                    startTime: "00:00",
                    endTime: "00:00"
                }
            }
        },
        methods: {
            concatDateTime() {
                if (this.model.type == 0) this.datetime.endDate = this.datetime.startDate;
                this.model.start = this.datetime.startDate + ' ' + this.datetime.startTime;
                this.model.end = this.datetime.endDate + ' ' + this.datetime.endTime;
            },
            submit() {
                this.loading = true
                this.axios
                    .post(
                        this.api.ACTIONS.LEAVES,
                        this.model
                    )
                    .then((res) => {
                        window.getApp.$emit("SHOW_TOAST", "Saved!", "green");
                        this.dialog = false;
                        this.$refs.datatable.addItemToTable(Object.assign(res.data.data), false);
                    })
                    .catch((err) => {
                        let message = '';
                        try {
                            message = err.response.data.message;
                        } catch (e) {
                            message = 'failed, Server error';
                        }
                        window.getApp.$emit('SHOW_TOAST', message, 'red');
                    })
                    .finally(() => (this.loading = false));
            }
        },
        computed: {
            titles() {
                return {
                    id: '#',
                    date: 'Date',
                    reason: 'Reason',
                    category: 'Category',
                    type: 'Type',
                    approved: 'Status',
                    paid: 'Paid',
                    reject_reason: 'Reject Reason',
                    handler: 'Handler'
                }
            },
            formatter() {
                return {
                    type: (value) => value == 0 ? 'Half' : 'Full',
                    paid: (value) => value == 0 ? 'No' : 'Yes',
                    date: (value) => value.slice(0, 16),
                    approved: (value) => {
                        if (value == null) return 'Pending';
                        else if (value == 1) return 'Approved';
                        else return 'Rejected';
                    }
                }
            },
            fieldsExtraMain() {
                return {
                    handler: (value) => {
                        return value.first_name ? value.first_name + ' ' + value.last_name : ' '
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>
